module.exports = __webpack_public_path__ + "img/to.e1a733f8.svg";